import * as React from 'react'
import Filter from './Filter'
import Table from './Table'
import { useProductionPlanningOverviewQuery } from '../../hooks/queries/production_planning'
import { useStorageState } from 'react-storage-hooks'
import { useEffect, useState } from 'react'
import { ProductionPlanningFilterShape } from './FilterForm'

type OverviewProps = {
  area: string
}

export default function Overview(props: OverviewProps) {
  const { area } = props

  const defaultFilter: ProductionPlanningFilterShape = {
    areas: [area],
    production_places: ['east'],
    status_code: 'ALL',
    hide_items: false,
    collapse_job_ids: false,
  }

  const [filter, setFilter] = useStorageState<ProductionPlanningFilterShape>(sessionStorage, 'production-planning-filter', defaultFilter)
  const [showCompletedToday, setShowCompletedToday] = useStorageState(sessionStorage, 'production-planning-show-completed-today', false)
  const [searchText, setSearchText] = useState('')
  // Handle both new array fields and legacy single-value fields
  const hasValidFilter = (filter?.areas && filter.areas.length > 0) || filter?.area
  const populatedFilter = hasValidFilter ? filter : defaultFilter
  const { isFetching, isError, data, error } = useProductionPlanningOverviewQuery(populatedFilter, showCompletedToday)
  const productionPlanningLines = data || {}
  useEffect(() => {
    const hasValidFilter = (filter?.areas && filter.areas.length > 0) || filter?.area
    if (!hasValidFilter) {
      setFilter(defaultFilter)
    }
  }, [])

  return (
    <div>
      <Filter
        filter={populatedFilter}
        setFilter={setFilter}
        showCompletedToday={showCompletedToday}
        setShowCompletedToday={setShowCompletedToday}
        searchText={searchText}
        setSearchText={setSearchText}
      />
      <Table
        isError={isError}
        error={error}
        isLoading={isFetching}
        productionPlanningLines={productionPlanningLines}
        areas={populatedFilter.areas || (populatedFilter.area ? [populatedFilter.area] : [])}
        filter={populatedFilter}
        showCompletedToday={showCompletedToday}
        searchText={searchText}
      />
    </div>
  )
}
